// @ts-check

// const workaround = require('next-translate/lib/cjs/plugin/utils');
// workaround.defaultLoader = '(l, n) => import(`locales/${l}/${n}.json`).then(m => m.default)';

/**
 * @type {import('next-translate').I18nConfig} config
 */
module.exports = {
  locales: ['vi', 'en'],
  defaultLocale: 'en',
  // domains: [
  //   {
  //     domain: process.env.EXAM_US_DOMAIN,
  //     defaultLocale: 'en',
  //   }
  // ],
  localeDetection: false,
  pages: {
    '*': [
      'common',
      'error',
      'modal',
      'auth',
      'account',
      'theme',
      'packages',
      'misc',
      'feedback',
      'settings',
    ],
    // Auth Routes
    'rgx:(/login|/signup|/recover)$': ['auth'],

    // User Profile & Settings
    'rgx:(/create-profile|/profiles|/edit-profile|/edit-profile/info-user|/learning-profile)': [
      'account',
      'edit_profile',
      'learning_profile',
      'achievements',
      'avatar',
      'diamonds',
      'settings',
    ],
    'rgx:(/settings)': ['settings'],

    // History & Results
    'rgx:(/history|/test-results|/mistakes)': [
      'history',
      'statement_result',
      'writing_result',
      'speaking_result',
      'practice_word',
      'note',
      'translate'
    ],

    // Real-time conversation topic (must be before Practice & Exam Core)
    'rgx:(/real-time-conversation/topic)': ['conversation', 'practice_player'],

    // IELTS Speaking
    'rgx:(/ielts/speaking)': ['ielts', 'ket_pet_speaking', 'do_exam', 'practice_player'],

    // IELTS Writing
    'rgx:(/ielts/writing)': [
      'ielts',
      'writing',
      'do_exam',
      'practice_player',
    ],

    // IELTS Listening & Reading
    'rgx:(/ielts/(listening|reading))': [
      'ielts',
      'do_exam',
      'practice_player',
      'practice_libraries',
    ],

    // IELTS general
    'rgx:(/ielts)': ['ielts', 'practice_libraries'],

    // Practice & Check-point
    'rgx:(/practice|/libraries|/ielts)': [
      'ielts',
      'practice',
      'writing',
      'do_exam',
      'practice_libraries',
      'practice_player',
      'note',
      'practice_word',
      'conversation',
      'ket_pet_speaking',
      'translate'
    ],

    // Mission
    'rgx:(/mission)': [
      'ielts',
      'practice',
      'practice_libraries',
      'conversation',
      'statement_result',
    ],

    // Active Account
    '/active-account': ['active_account'],

    // Specific features
    'rgx:(/real-time-conversation)': ['conversation'],
    'rgx:(/join-placementest)': ['placement_test'],
    'rgx:(/home|/)': ['homepage', 'practice_libraries', 'diamonds', 'ielts'],
  },
  // @ts-ignore
  // require() với path nội suy là context module của webpack; Turbopack không dựng
  // được map đó. import() template literal thì Turbopack glob ra đúng danh sách file
  // lúc build, nên đây là dạng duy nhất chạy được với cả hai bundler.
  loadLocaleFrom: (lang, ns) =>
    import(`./src/locales/${lang}/${ns}.json`).then((m) => m.default),
  logBuild: true,
};
